export default __webpack_public_path__ + "static/media/arrow_up.fd1274d7.svg";